import { Device } from "@/types/device";

export function exportDevicesAsCsv(devices: Device[], filename = "device-inventory.csv") {
  const headers = [
    "Name", "Platform", "OS Version", "Status", "Serial Number",
    "Hostname", "IP Address", "Model", "Product",
    "Battery Level", "Battery Status", "Last Seen", "Created At",
    "Username", "Email", "UDID", "WiFi MAC",
  ];

  const rows = devices.map((d) => [
    d.name,
    d.os_type,
    d.os_version,
    d.status,
    d.serial_number ?? "",
    d.hostname,
    d.ip_address ?? "",
    d.model ?? "",
    d.product ?? "",
    d.battery_level != null ? String(d.battery_level) : "",
    d.battery_status ?? "",
    d.last_seen,
    d.created_at,
    d.username ?? "",
    d.userEmail ?? "",
    d.deviceAdditionalProperties?.UDID ?? "",
    d.deviceAdditionalProperties?.WiFiMAC ?? "",
  ]);

  const escape = (v: string) => {
    if (v.includes(",") || v.includes('"') || v.includes("\n")) {
      return `"${v.replace(/"/g, '""')}"`;
    }
    return v;
  };

  const csv = [headers, ...rows].map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
